import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/smea/Table/EditableTable";
import ConfirmationModal from "modals/smea/miscellaneous/ConfirmationModal";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function UsersTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [selectedUser, setSelectedUser] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);

  setSelectedData(selectedUser);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse && rowToDelete) {
      setLoading(true);

      axiosPrivate
        .delete(`/user/delete/${rowToDelete[0]?.uid}`, data)
        .then(() => {
          alert("User deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    // { field: "uid", headerName: "ID", width: 70 },
    { field: "username", headerName: "Username", width: 150 },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "officeName",
      headerName: "School/Office",
      width: 500,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loading || loadingState}
        singleSelect
        setSelectedData={setSelectedUser}
        rowToDelete={setRowToDelete}
        height="60vh"
        showSearch
        remove
      />
    </Box>
  );
}
